@if (!shown) {
    <print-button
        (notifyOpen)="notifyOpen($event)"
        [buttonText]="'Enthaftungserklärung'"></print-button>
} @else {
    <div id="printDialogue">
        <div print-header (notifyOpen)="notifyOpen($event)"></div>
        <!-- Start printContent: Enthaftungserklärung -->
        <div class="printContent alsBriefbogen show"><!-- Zusatzklasse! -->
            <!-- DOCUMENT TITLE -->
            <h1 class="printTitle">
                Ihre Enthaftungserklärung
            </h1>
            <!-- CONTENT START -->
            <!-- Enthaftungserklärung -->
            <div class="gridContainer">
                <div class="gridContainer dataGrid">
                    <div class="row zoneAnschrift">
                        <div class="cell grid-100">
                            <span class="label">VHV Allgemeine Versicherung AG</span>
                            <span class="label">VHV-Platz 1</span>
                            <span class="label">30177 Hannover</span>
                        </div>
                    </div>
                </div>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Bürgschein-Nr.:</span>
                                    <span>&nbsp;</span>
                                    <span class="value">{{ model.vsnr }}/{{ model.buergscheinnummer }}</span>
                                </div>
                                <div class="dataItem">
                                    <span class="label">Bürgschaftsbetrag:</span>
                                    <span>&nbsp;</span>
                                    <span class="value">{{ model.buergschaftsBetrag | formatMoney }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-100">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Baumaßnahme:</span>
                                    <div class="valueGroup">
                                        <span class="value">{{ model.auftrag1 }}</span>
                                        <span class="value">{{ model.auftrag2 }}</span>
                                        <span class="value">{{ model.auftrag3 }}</span>
                                        <span class="value">{{ model.auftrag4 }}</span>
                                        <span class="value">{{ model.auftrag5 }}</span>
                                        <span class="value">{{ model.auftrag6 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Auftragnehmer:</span>
                                    <div class="valueGroup">
                                        <span class="value">{{ partnerModel.nachnameOderName1.value }} {{ partnerModel.vornameOderName2.value }}</span>
                                        <span class="value">{{ partnerModel.name3.value }}</span>
                                        <span class="value">{{ partnerModel.name4.value }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.strasse }} {{ partnerModel.anschriftAllgemein.value.postfach }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.plz }}&nbsp;{{ partnerModel.anschriftAllgemein.value.ort }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile1 }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile2 }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile3 }}</span>
                                        <span class="value">{{ partnerModel.anschriftAllgemein.value.zeile4 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cell grid-50">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Auftraggeber:</span>
                                    <div class="valueGroup">
                                        <span class="value">{{ model.auftraggeberinfo1 }}</span>
                                        <span class="value">{{ model.auftraggeberinfo2 }}</span>
                                        <span class="value">{{ model.auftraggeberinfo3 }}</span>
                                        <span class="value">{{ model.auftraggeberinfo4 }}</span>
                                        <span class="value">{{ model.auftraggeberinfo5 }}</span>
                                        <span class="value">{{ model.auftraggeberinfo6 }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h2>Enthaftungserklärung</h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-100">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">
                                        Als Auftraggeber aus der im Betreff genannten Baumaßnahme erkläre ich/erklären wir Ihnen hiermit rechtsverbindlich
                                        und unwiderruflich, dass ich/wir aus der Bürgschaft keinerlei Ansprüche mehr herleite(n), die Rechte hieraus nicht
                                        an Dritte abgetreten sind, die Bürgschaftsurkunde hiermit als zurückgegeben gilt.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-100">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">
                                        Ich/Wir erkläre/n rechtsverbindlich, dass ich/wir für den/die Auftraggeber alleinvertretungsbefugt bin/sind.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-50">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Ort, Datum</span>
                                </div>
                            </div>
                        </div>
                        <div class="cell grid-50">
                            <div class="dataGroup">
                                <div class="dataItem">
                                    <span class="label">Unterschrift und Stempel des Auftraggebers</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
